import React, { useEffect, useState } from "react";
import { Box, Button, Flex, Group, Switch, Text, TextInput } from "@mantine/core";
import { notificationError, notificationSuccess } from "../../ui/Notification";
import { addApplication, updateApplication } from "../../../services/application";
import { validation } from "../../../plugins/validation";

const defaultVal = {
  name: "",
  url: "",
  isActive: false,
};

const formValidation = {
  name: {
    isError: false,
    message: "",
  },
  url: {
    isError: false,
    message: "",
  },
  isActive: {
    isError: false,
    message: "",
  },
};
const FormApplication = ({ dataApplication, onCloseModal, reloadList }) => {
  const [loadingForm, setLoadingForm] = useState(false);
  const [formData, setFormData] = useState(defaultVal);
  const [validationForm, setValidationForm] = useState(formValidation);
  console.log(formData);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSwitch = () => {
    setFormData({ ...formData, isActive: !formData.isActive });
  };

  useEffect(() => {
    if (dataApplication !== null) {
      handleSetForm(dataApplication);
    }
    // eslint-disable-next-line
  }, [dataApplication]);

  const handleSetForm = (dataApplication) => {
    const dataDetail = {
      name: dataApplication?.name,
      url: dataApplication?.url,
      isActive: dataApplication?.isActive,
    };
    setFormData(dataDetail);
  };

  const handleSubmit = async (data) => {
    let methodFunction = null;
    let titleMessageSuccess = "";
    let captionMessageSuccess = "";
    let titleMessageError = "";
    let captionMessageError = "";
    setLoadingForm(true);
    setValidationForm(formValidation);
    const payload = {
      name: data.name,
      url: data.url,
      isActive: Boolean(data.isActive),
    };
    const isError = validation(payload, setValidationForm);
    if (isError) {
      setLoadingForm(false);
      return;
    }
    if (dataApplication !== null) {
      methodFunction = updateApplication(dataApplication?.id, payload);
      titleMessageSuccess = "Update Aplikasi Berhasil";
      captionMessageSuccess = "Anda telah berhasil mengupdate data Aplikasi";
      titleMessageError = "Gagal Mengupdate Aplikasi";
      captionMessageError = "Silahkan cek kembali form anda";
    } else {
      methodFunction = addApplication(payload);
      titleMessageSuccess = "Tambah Aplikasi Berhasil";
      captionMessageSuccess = "Anda telah berhasil menambahkan Aplikasi baru";
      titleMessageError = "Gagal Menambahkan Aplikasi";
      captionMessageError = "Silahkan cek kembali form anda";
    }
    try {
      const response = await methodFunction;
      if (response) {
        onCloseModal();
        reloadList();
        notificationSuccess(titleMessageSuccess, captionMessageSuccess);
      }
    } catch (error) {
      const errorMessage = error.response.data.message;
      notificationError(titleMessageError, `${Object.keys(errorMessage) ? errorMessage : captionMessageError}`);
      Object.values(errorMessage).forEach((el) => {
        Object.keys(formValidation).forEach((element) => {
          if (el.includes(element)) {
            setValidationForm((old) => ({
              ...old,
              [element]: {
                ...old?.[element],
                isError: true,
                message: el,
              },
            }));
          }
        });
      });
    } finally {
      setLoadingForm(false);
    }
  };

  return (
    <Box>
      <Box mb="md">
        <TextInput name="name" value={formData.name} label="Nama Aplikasi" placeholder="Masukkan nama aplikasi" error={validationForm.name.isError ? `${validationForm.name.message}` : ""} onChange={handleChange} withAsterisk />
      </Box>
      <Box mb="md">
        <TextInput name="url" value={formData.url} label="URL Aplikasi" placeholder="Masukkan url aplikasi" error={validationForm.url.isError ? `${validationForm.url.message}` : ""} onChange={handleChange} withAsterisk />
      </Box>

      <Box mb="md">
        <Flex justify="flex-start">
          <Text fz={14} mx={3} mr={8}>
            Active :{" "}
          </Text>
          <Switch onLabel="YES" offLabel="NO" checked={formData.isActive} onChange={handleSwitch} />
        </Flex>
      </Box>

      <Box mt={20}>
        <Flex justify="flex-end">
          <Group>
            <Button variant="outline" color="indigo.9" onClick={onCloseModal}>
              Tutup
            </Button>
            <Button loading={loadingForm} variant="filled" color="indigo.9" onClick={() => handleSubmit(formData)}>
              Simpan
            </Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  );
};

export default FormApplication;
